<button
    class="flex items-center gap-2 font-semibold leading-5 text-primary dark:text-contrast-yellow"
    [attr.aria-label]="'LOCAL_BTN_BACK' | translate">
    <ion-icon
        class="orb-app-light:text-secondary var-app-light:text-primary var-app-light-dark:text-2xl text-xl"
        *ngIf="showArrow"
        [ngClass]="classIcon"
        name="arrow-back-outline"
        slot="end"
        aria-hidden="true"></ion-icon>
    <a
        [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
        (click)="back()"
        (keydown.enter)="back()"
        (keydown.space)="back()"
        tabindex="0">
        <ng-content></ng-content>
    </a>
</button>
